import { useState, useEffect } from "react";
import axios from "axios";
import MainLayout from "../layouts/MainLayout";
import AddTechnician from "./AddTechnician";
import EditTechnician from "./EditTechnician";

function Technicians() {

const [technicians,setTechnicians]=useState([]);
const [search,setSearch]=useState("");

const [showAddDialog,setShowAddDialog]=useState(false);

const [showEditDialog,setShowEditDialog]=useState(false);

const [selectedTechnician,setSelectedTechnician]=useState(null);

useEffect(()=>{

loadTechnicians();

},[]);

const loadTechnicians=async()=>{

try{

const token=localStorage.getItem("token");

const response=await axios.get(

"https://saleupcall.com/api/Technician/get-technicians.php",

{
headers:{
Authorization:`Bearer ${token}`
}
}

);

if(response.data.status){

setTechnicians(
response.data.data
);

}

}
catch(error){

console.log(error);

}

};

const filteredTechnicians=

technicians.filter(

(technician)=>

(technician.username || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(technician.employee_code || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(technician.mobile || "")
.includes(search)

||

(technician.department_name || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(technician.designation_name || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(technician.skills || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(technician.status || "")
.toLowerCase()
.includes(search.toLowerCase())

);

const deleteTechnician=async(id)=>{

if(
!window.confirm(
"Delete this technician?"
)
){
return;
}

const token=
localStorage.getItem(
"token"
);

const response=
await axios.post(

"https://saleupcall.com/api/Technician/delete-technician.php",

{
id:id
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Deleted"
);

loadTechnicians();

}

}

return(

<MainLayout>

<div className="container mt-1">

<div className="row mb-2">

<div className="col-md-4">

<h4>Technicians</h4>

</div>

<div className="col-md-6">

<input
type="text"
className="form-control form-control-sm"
placeholder="Search Technician"
value={search}
onChange={(e)=>
setSearch(
e.target.value
)
}
/>

</div>

<div className="col-md-2">

<button
className="btn btn-success btn-sm w-100"
onClick={()=>
setShowAddDialog(true)
}
>

<i className="bi bi-plus-lg"></i>

Add

</button>

</div>

</div>

<div className="table-responsive">

<table className="table table-bordered table-hover table-striped table-sm">

<thead className="table-success">

<tr>

<th>ID</th>
<th>Employee Code</th>
<th>Mobile</th>
<th>Department</th>
<th>Designation</th>
<th>Skills</th>
<th>Status</th>
<th>Username</th>
<th>Email</th>

<th width="150">

Actions

</th>

</tr>

</thead>

<tbody>

{

filteredTechnicians.map(

(technician)=>(

<tr key={technician.id}>

<td>{technician.id}</td>

<td>{technician.employee_code}</td>

<td>{technician.mobile}</td>

<td>{technician.department_name}</td>

<td>{technician.designation_name}</td>

<td>{technician.skills}</td>

<td>{technician.status}</td>

<td>{technician.username}</td>

<td>{technician.email}</td>

<td>

<button
className="btn btn-primary btn-sm me-1"
title="Edit"
onClick={()=>{

setSelectedTechnician(technician);

setShowEditDialog(true);

}}
>

<i className="bi bi-pencil"></i>

</button>

<button
className="btn btn-danger btn-sm me-1"
onClick={()=>deleteTechnician(technician.id)}
>

<i className="bi bi-trash"></i>

</button>

<button
className="btn btn-info btn-sm"
title="View"
>

<i className="bi bi-eye"></i>

</button>

</td>

</tr>

)

)

}

</tbody>

</table>

</div>

</div>

{
showAddDialog && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-xl">

<div className="modal-content">

<div className="modal-header">

<h5 className="modal-title">

Add Technician

</h5>

<button
type="button"
className="btn-close"
onClick={()=>
setShowAddDialog(false)
}
></button>

</div>

<div className="modal-body">

<AddTechnician

onClose={()=>{

setShowAddDialog(false);

loadTechnicians();

}}

/>

</div>

</div>

</div>

</div>

)

}

{

showEditDialog &&
selectedTechnician && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-xl">

<div className="modal-content">

<div className="modal-header">

<h5 className="modal-title">

Edit Technician

</h5>

<button
type="button"
className="btn-close"
onClick={()=>{

setShowEditDialog(false);

setSelectedTechnician(null);

}}
>

</button>

</div>

<div className="modal-body">

<EditTechnician

technician={selectedTechnician}

onClose={()=>{

setShowEditDialog(false);

setSelectedTechnician(null);

loadTechnicians();

}}

/>

</div>

</div>

</div>

</div>

)

}

</MainLayout>

);

}

export default Technicians;